// extracted by mini-css-extract-plugin
export var cardHeader = "_t9-0";
export var reorderHandle = "_t9-3";
export var titleArea = "_t9-1";
export var titleAreaWithHandle = "_t9-2";